<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>B/L (US)</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!-- originalDone==false -->
              <Filter-Agency-Modal />
              <FilterCBModal />
              <ClientCard />
               <ShipmentTrackCard />
              <span v-if="blTableArray.length==1">
                <b-button
                  v-if=" BLRaised.fclBlId != '' && BLRaised.fclBlId != undefined && originalDone==true"
                  @click="openPopBLMail"
                  size="sm"
                  variant="warning"
                >Edit BL Request</b-button>
                <b-button
                  style="margin-left:5px"
                  v-if="(BLRaised.fclBlId != '' || blTableArray.length)"
                  @click="Print(BLRaised.uploadBL)"
                  size="sm"
                  variant="warning"
                >B/L PDF</b-button>
                <b-button
                  style="margin-left:5px"
                  @click="downloadWord(BLRaised.fclBlId)"
                  v-if="(BLRaised.fclBlId != '' || blTableArray.length)"
                  size="sm"
                  variant="warning"
                >B/L Word</b-button>
              </span>
              <b-button
                style="margin-left:5px"
                v-if="BLRaised.fclBlId!='' || blTableArray.length"
                variant="warning"
                size="sm"
                class="pull-right"
                id="addButtonLoader"
                @click="proceedToTally"
              >Proceed To Invoice</b-button>
              <!-- <b-button
                style="margin-left:5px"
                size="sm"
                v-if="splitBlList.length>0 || allData[0].typeOfBL=='1'"
                @click="deleteAllBL"
                variant="danger"
              >Delete B/L</b-button> -->
              <b-button
                style="margin-left: 5px"
                size="sm"
                v-if="blTableArray.length > 0"
                @click="AddMoreBL"
                variant="info"
                :disabled="(sentAdditionalBL==2 || sentAdditionalBL==1)?true:false"
              >ADD B/L</b-button>
              <!-- :disabled='sentAdditionalBL==2?true:false' -->
              <!-- <b-button
                v-if="BLRaised.fclBlId != '' && (this.$sessionsStorage.get('designation') == 'Admin' || this.$sessionsStorage.get('userId') == '110')&& originalDone==true"
                @click="openNoteModal('1')"
                size="sm"
                variant="warning"
                style="margin-left: 5px"
                >Credit Note</b-button
              >-->
              <!-- <b-button
                style="margin-left: 5px"
                v-if="BLRaised.fclBlId != '' && (this.$sessionsStorage.get('designation') == 'Admin' || this.$sessionsStorage.get('userId') == '110') && originalDone==true"
                @click="openNoteModal('2')"
                size="sm"
                variant="warning"
                >Debit Note</b-button
              >-->

              <!-- @click="openPopMail" -->
              <!-- <b-button
                style="margin-left: 5px"
                v-if="BLRaised.fclBlId!=''"
                @click="openPopMail"
                size="sm"
                variant="warning"
              >Send Pre-Alert Mail</b-button>-->

              <b-button
                style="margin-left: 5px"
                v-if="BLRaised.fclBlId!=''"
                @click="openPreAlert"
                size="sm"
                variant="warning"
              >Send Pre-Alert Mail</b-button>
              <!-- {{BLRaised}} -->
              <!-- <Prealert-Mail
                v-if="BLRaised.fclBlId!=''"
                :pre_ffExportFclId="BLRaised.ffExportFclId"
                :pre_allModuleId="allData[0].allModuleId"
                :pre_title="'FCL Pre-Alert Mail Send'"
                :pre_moduleType="'FCL Export'"
                :pre_fclBlId="BLRaised.fclBlId"
                :pre_blDate="BLRaised.blDate"
                :pre_item="BLRaised"
                :pre_allData="allData"
                :pre_prealert_id="preAlertData.fclAlertId"
                :pre_ffType="'FF Export'"
                :pre_prealertDetails="allData[0].prealertDetails"
              />-->
              <!-- {{allData[0].prealertDetails}} -->
              <!-- :pre_prealertDetails="prealertDetails" -->

              <!-- <b-button
                style="margin-left:5px"
                v-if="billLandingModel.blLandingId!=''"
                variant="warning"
                class="pull-right"
                id="addButtonLoader"
                @click="proceedToTally"
              >Proceed To Invoice</b-button>-->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.allData[0].allModuleId ? this.allData[0].allModuleId : ''"
          :jobSeriesBanner="this.allData[0].ffExportFclSeries ? this.allData[0].ffExportFclSeries : ''"
          :bannerClientName="this.allData[0].clientName ? this.allData[0].clientName : '' "
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div class="mt-2">
              <!-- <b-button
                size="sm"
                variant="outline-info"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
              >Hide Details</b-button>-->
              <!-- <b-collapse id="collapse-4" v-model="visible" class="mt-2">
                <b-card class="HeaderMastBanner">
                  <md-layout gutter>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <b>
                          Client Name : {{allData[0].clientName}}
                          <br>
                        </b>
                        <b>
                          Assignment No. : {{allData[0].ffExportFclSeries}}
                          <br>
                        </b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <b>
                          FF Activity : {{allData[0].containerInfo}}
                          <br>
                        </b>
                        <b>
                          Stuffing Type : {{allData[0].stuffingType}}
                          <br>
                        </b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                        <b>Shipping Line : {{allData[0].shippingLine}}</b>
                      
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </b-card>
              </b-collapse>-->
            </div>

            <div class="mt-3" v-if="containerTypeDetailFactory.length>0 ">
              <div>
                <h5>
                  <b-badge>Container Details</b-badge>
                </h5>

                <md-spinner md-indeterminate id="loaderD" style="display:none"></md-spinner>
              </div>

              <div class="table-responsive tableMain">
                <table id="ffContainer" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>
                          <input 
                            type="checkbox" 
                            v-model="selectAllContainers" 
                            @change="toggleSelectAll"
                            :indeterminate="isIndeterminate"
                          />
                        </th>
                      <th>Container No.</th>
                      <th>Container Type</th>
                      <th>Custom Seal No</th>
                      <th>Line Seal No</th>
                      <th>Measurement</th>
                      <th>Gross Weight</th>
                      <th>Package Details</th>
                      <th v-if="allData[0].typeOfBL=='2'">Container Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in containerTypeDetailFactory" :key="index">
                      <td>
                          <input 
                            type="checkbox" 
                            v-model="item.selected" 
                            @change="updateSelectAll"
                            :disabled="item.containerWithSplit == 1"
                          />
                        </td>
                      <td>{{item.containerNo }}</td>

                      <td>{{item.containerType }}</td>
                      <td>{{item.customSealNo }}</td>
                      <td>{{item.LineSealNo }}</td>
                      <td>{{item.measurement }}</td>
                      <td>{{item.grossWeight }} {{item.weightUnit }}</td>
                      <td>{{item.noOfpkgUnit }} {{item.packageName }}</td>
                      <td v-if="allData[0].typeOfBL=='2' ">
                        <md-switch
                          :id="'approval'+item.ffExecutionContainerId"
                          name="approval"
                          class="md-primary"
                          @change="activateUser(item,index)"
                          v-model="activateIndex[index]"
                          :disabled="item.containerWithSplit==1?true:false"
                        ></md-switch>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Container selection controls -->
              <div class="mt-3" v-if="containerTypeDetailFactory.length > 0">
                  <div class="alert alert-info">
                    <strong>Container Selection:</strong> Use the checkboxes to select individual containers or use the controls below for bulk operations. 
                    Selected containers can be used for specific operations. Containers with split status are disabled.
                  </div>
                    <!-- Warning when no containers are selected -->
                    <div v-if="!hasSelectedContainers" class="alert alert-warning">
                    <strong>Warning:</strong> Please select at least one container to proceed.
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <b-button 
                        size="sm" 
                        variant="info" 
                        @click="selectAllContainers = true; toggleSelectAll()"
                        class="mr-2"
                      >
                        Select All
                      </b-button>
                      <b-button 
                        size="sm" 
                        variant="secondary" 
                        @click="selectAllContainers = false; toggleSelectAll()"
                        class="mr-2"
                      >
                        Deselect All
                      </b-button>
                    </div>
                    <div class="col-md-6 text-right">
                      <span class="text-muted">
                        Selected: {{ selectedContainersCount }} of {{ selectableContainersCount }} containers
                      </span>
                    </div>
                  </div>
                </div>
            </div>

            <div v-if="(validateContainerSplit==false ) || BLRaised.fclBlId!='' ">
              <md-layout md-gutter class="labelMargtop">
                <!-- :list="originalDone==false ?blStageList:blStageListAfterOriginalCreated" -->

                <md-layout md-flex="45">
                  <label for="blType">B/L Stage *</label>
                  <model-list-select
                    @input="checBlstage"
                    :list="originalDone==false ?blStageList:blStageListAfterOriginalCreated"
                    v-model="BLRaised.blStage"
                    option-value="blStageVal"
                    option-text="blStageTxt"
                    placeholder="Select B/L Stage"
                  ></model-list-select>
                  <span class="error" v-if="!BLRaised.blStage">{{errorBLRaised.blStage}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <label>B/L Date</label>
                  <!-- :not-before="new Date()" -->
                  <date-picker v-model="BLRaised.blDate" lang="en" id="blDate" name="blDate"></date-picker>
                  <span class="error" v-if="!BLRaised.blDate">{{errorBLRaised.blDate}}</span>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="30">
                  <label>Consignor</label>
                  <!-- <label>Exporter/Shipper</label> -->
                </md-layout>
                <md-layout md-flex="20"></md-layout>
                <md-layout md-flex="35">
                  <label>CONSIGNEE ( OR ORDER)</label>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <!-- {{BLRaised}} -->
                    <quill-editor
                      style="width:100% !important"
                      ref="consignor"
                      v-model="BLRaised.consignor"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.consignor">{{errorBLRaised.consignor}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <quill-editor
                      style="width:100% !important"
                      ref="myTextEditor"
                      v-model="BLRaised.consignee"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.consignee">{{errorBLRaised.consignee}}</span> -->
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout
                  md-flex="30"
                  v-for="(singleInput, index) in BLRaised.notifyList"
                  :key="index"
                >
                  <md-layout md-flex="100">
                    <md-layout md-flex="60">
                      <label>{{ notifyArray[index] }} Notify Party</label>
                    </md-layout>
                    <md-layout md-flex="25"></md-layout>
                    <md-layout md-flex="10" v-if="index>1">
                      <md-button
                        class="md-icon-button md-raised md-dense"
                        @click="removeNotify(index)"
                        style="min-height:20px;height:20px;margin-top:25px"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="100">
                    <md-layout md-flex="90">
                      <quill-editor
                        class="mt-2"
                        style=" width: 100% !important;"
                        ref="myTextEditor"
                        v-model="singleInput.inputValue"
                      ></quill-editor>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter class="labelMargtop">
                <md-layout md-flex="30">
                  <b-button size="sm" variant="outline-dark" @click="addNotify">Add More Notify</b-button>
                  <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Booking No</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="bookingNo"
                      ref="bookingNo"
                      name="bookingNo"
                      v-model="BLRaised.bookingNo"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.bookingNo">{{errorBLRaised.bookingNo}}</span> -->
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Consolidation No</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="consolidationNO"
                      name="consolidationNO"
                      v-model="BLRaised.consolidationNO"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.consolidationNO">{{errorBLRaised.consolidationNO}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>SCAC</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="SCAC"
                      name="SCAC"
                      v-model="BLRaised.SCAC"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.SCAC">{{errorBLRaised.SCAC}}</span> -->
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Type of Move</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="typeMove"
                      name="typeMove"
                      v-model="BLRaised.typeMove"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.typeMove">{{errorBLRaised.typeMove}}</span> -->
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Export References</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="exportReference"
                      name="exportReference"
                      v-model="BLRaised.exportReference"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.exportReference">{{errorBLRaised.exportReference}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Shipper References</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="shippingReferenceNum"
                      name="shippingReferenceNum"
                      v-model="BLRaised.shippingReferenceNum"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span
                class="error"
                v-if="!BLRaised.shippingReferenceNum"
                  >{{errorBLRaised.shippingReferenceNum}}</span>-->
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <label for="blType">Forwarding Agent</label>
                  <model-list-select
                    @input="getForwardAgentName"
                    :list="AgentList"
                    v-model="BLRaised.forwardingAgent"
                    option-value="agntColoaderId"
                    option-text="agentName"
                    placeholder="Select  Agent"
                  ></model-list-select>
                  <!-- <span class="error" v-if="!BLRaised.forwardingAgent">{{errorBLRaised.forwardingAgent}}</span> -->
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Pre­Carriage By</label>
                    <b-form-input :formatter="capitalizeAll" id name v-model="BLRaised.preCarriage"></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.preCarriage">{{errorBLRaised.preCarriage}}</span> -->
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <label for="blType">Delievery Agent</label>
                  <model-list-select
                    @input="getAgentName"
                    :list="AgentList"
                    v-model="BLRaised.delieveryAgent"
                    option-value="agntColoaderId"
                    option-text="agentName"
                    placeholder="Select Delievery Agent"
                  ></model-list-select>
                  <!-- <span class="error" v-if="!BLRaised.delieveryAgent">{{errorBLRaised.delieveryAgent}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Point of Origin/FTZ No.</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="pointofOrigin"
                      name="pointofOrigin"
                      v-model="BLRaised.pointofOrigin"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.pointofOrigin">{{errorBLRaised.pointofOrigin}}</span> -->
                </md-layout>
              </md-layout>
              <md-layout md-gutter>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Place of Receipt By Pre-Carrier</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="placeReceipt"
                      name="placeReceipt"
                      v-model="BLRaised.placeReceipt"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.placeReceipt">{{errorBLRaised.placeReceipt}}</span> -->
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Loading Peer / Terminal</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="loadingPreTerminal"
                      name="loadingPreTerminal"
                      v-model="BLRaised.loadingPreTerminal"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span
                class="error"
                v-if="!BLRaised.loadingPreTerminal"
                  >{{errorBLRaised.loadingPreTerminal}}</span>-->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Vessel/Voy</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="vesselVoy"
                      name="vesselVoy"
                      v-model="BLRaised.vesselVoy"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.vesselVoy">{{errorBLRaised.vesselVoy}}</span> -->
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Port of Loading</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="portLoad"
                      name="portLoad"
                      v-model="BLRaised.portLoad"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.portLoad">{{errorBLRaised.portLoad}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Port of Discharge</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="portDischarge"
                      name="portDischarge"
                      v-model="BLRaised.portDischarge"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.portDischarge">{{errorBLRaised.portDischarge}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Place of Delivery</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="placeDilievery"
                      name="placeDilievery"
                      v-model="BLRaised.placeDilievery"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.placeDilievery">{{errorBLRaised.placeDilievery}}</span> -->
                </md-layout>
              </md-layout>

              <md-layout gutter>
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Refrences</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="reference"
                      name="reference"
                      v-model="BLRaised.reference"
                    ></b-form-textarea>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.reference">{{errorBLRaised.reference}}</span> -->
                </md-layout>
              </md-layout>

              <md-layout gutter>
                <!-- <md-layout md-flex="30">
              <label>Container No. / Marks and Nos</label>
                </md-layout>-->
                <md-layout md-flex="45">
                  <label>Description of Packages and Goods</label>
                </md-layout>
                <!-- <md-layout md-flex="20">
              <label>No. of Pkgs</label>
                </md-layout>-->
              </md-layout>
              <md-layout gutter>
                <!-- <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor
                  ref="myTextEditor"
                  v-model="BLRaised.containerMarks"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.containerMarks">{{errorBLRaised.containerMarks}}</span>
                </md-layout>-->
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <quill-editor
                      ref="myTextEditor"
                      style=" width: 100% !important;"
                      v-model="BLRaised.descriptionGood"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.descriptionGood">{{errorBLRaised.descriptionGood}}</span> -->
                </md-layout>
                <!-- <md-layout md-flex="10">
              <md-layout md-flex="100">
                <quill-editor ref="myTextEditor" v-model="BLRaised.noPkg" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.noPkg">{{errorBLRaised.noPkg}}</span>
                </md-layout>-->
              </md-layout>

              <!-- <md-layout gutter style="margin-top:2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Gross Weight</label>
            </md-layout>

            <md-layout md-flex="30">
              <label>Net Weight</label>
            </md-layout>
            <md-layout md-flex="30">
              <label>Measurement</label>
            </md-layout>
              </md-layout>-->
              <!-- <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.grossWeight" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.grossWeight">{{errorBLRaised.grossWeight}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.netWeight" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.netWeight">{{errorBLRaised.netWeight}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.measurement" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.measurement">{{errorBLRaised.measurement}}</span>
            </md-layout>
              </md-layout>-->
              <md-layout gutter>
                <md-layout md-flex="40">
                  <label>Description of Charges</label>
                </md-layout>
                <md-layout md-flex="35">
                  <label>Prepaid</label>
                </md-layout>

                <md-layout md-flex="20">
                  <label>Collect</label>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <md-layout md-flex="100">
                      <quill-editor
                        style=" width: 100% !important;"
                        v-model="BLRaised.desCharges"
                        :options="editorOption"
                      ></quill-editor>
                    </md-layout>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.desCharges">{{errorBLRaised.desCharges}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <quill-editor
                      style=" width: 100% !important;"
                      v-model="BLRaised.prepaid"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.prepaid">{{errorBLRaised.prepaid}}</span> -->
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <quill-editor
                      style=" width: 100% !important;"
                      v-model="BLRaised.collect"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.collect">{{errorBLRaised.collect}}</span> -->
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="35">
                  <label for="blType">Branch Name</label>
                  <model-list-select
                    @input="getBranchName"
                    :list="pridelBranchLocation"
                    v-model="BLRaised.placeBranch"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Pridel Branch Name"
                  ></model-list-select>
                  <!-- <span class="error" v-if="!BLRaised.placeBranch">{{errorBLRaised.placeBranch}}</span> -->
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Total</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="total"
                      name="total"
                      v-model="BLRaised.total"
                    ></b-form-input>
                  </md-layout>
                  <!-- <span class="error" v-if="!BLRaised.total">{{errorBLRaised.total}}</span> -->
                </md-layout>
              </md-layout>
              <h3
                v-if="BLRaised.blStage=='ORIGINAL'"
                class="error mt-3"
              >BL Will Be Uneditable Once ORIGINAL BL Is Created</h3>
              <h5 v-if="BLRaised.CreatedBY">
                <span
                  class="error"
                >Created = {{" "+BLRaised.CreatedBY + " -- " +BLRaised.CreatedDate}}</span>
              </h5>
              <h5 v-if="BLRaised.UpdatedBY">
                <span
                  class="error"
                >Updated = {{" "+BLRaised.UpdatedBY + " -- " +BLRaised.UpdatedDate}}</span>
              </h5>
              <!-- <h5 v-if="BLRaised.CreatedBY">
                <span
                  class="error"
                >Created/Updated = {{" "+BLRaised.CreatedBY + " -- " +BLRaised.createUpdate}}</span>
              </h5> -->
              <md-layout md-gutter>
                <!-- <md-layout md-flex="30">
              <md-button
                v-if="BLRaised.fclBlId!=''"
                class="md-raised md-primary md-button-color heght-1px"
                id="addButtonLoader"
                @click="downloadWord(BLRaised.fclBlId)"
              >Download Word</md-button>
                </md-layout>-->

                <md-layout class="justify-content-center">
                  <!-- <b-button class="mt-3" variant="warning" id="addButtonLoader" @click="addBLRaised('PREVIEW')">PREVIEW</b-button> -->
                  
                  <!-- :disabled="isButtonDisabled" -->
                  <b-button
                    class="mt-3"
                    variant="primary"
                    id="addButtonLoader"
                    @click="addBLRaised('SAVE')"
                  ><md-spinner
                  
                     v-if="isBlSubmited"
                  md-indeterminate
                  style="width: 20px; height: 20px"
                ></md-spinner>
                <span v-if="isBlSubmited">{{ countdown }}s</span>
    <span v-else>Save & Generate BL</span>

                <!-- Save & Generate BL {{ timer }} -->
                </b-button>
                <!-- :disabled="(savegenerateblprealertStatus == true || isBlSubmited) ? true : false" -->
                  <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                </md-layout>
                <!-- <md-layout md-flex="15"></md-layout>
            <md-layout md-flex="15">
              <h4 style="margin:0px" class="showMoreData" @click="Print">Preview B/L (PDF)</h4>
                </md-layout>-->
                <!-- <md-layout md-flex="15" v-if="BLRaised.fclBlId!=''">
              <md-button
                class="md-raised md-primary md-button-color heght-1px"
                id="addButtonLoaderpre"
                @click="Print"
              >Preview B/L</md-button>
              <md-spinner md-indeterminate id="loaderpre" style="display:none"></md-spinner>
                </md-layout>-->
              </md-layout>
            </div>

            <div class="box" v-if="allData[0].typeOfBL=='2' && splitBlList.length>0">
              <div class="box-header">
                <h3 class="box-title">
                  <u>Split B/L Details</u>
                </h3>
              </div>

              <!-- /.box-header -->
              <div class="table-responsive tableMain">
                <table id="ffContainer" class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>B/L Stage</th>
                      <th>Container No</th>

                      <th>Print</th>
                      <th>Download Word</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in splitBlList" :key="index">
                      <td class="showMoreData" @click="editBLRaised(item)">{{item.blStage }}</td>
                      <td>
                        <span
                          v-for="(item1,index1) in item.containerDetailAll.split(',')"
                          :key="index1"
                        >
                          {{item1 }}
                          <br />
                        </span>
                      </td>

                      <!-- <td>{{item.containerType }}</td>
                      <td>{{item.customSealNo }}</td>-->
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="Print(item.uploadBL)"
                        >
                          <md-icon>print</md-icon>
                        </md-button>
                      </td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="downloadWord(item.fclBlId)"
                        >
                          <md-icon>cloud_download</md-icon>
                        </md-button>
                      </td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="deleteData(item)"
                        >
                          <md-icon>delete</md-icon>
                        </md-button>
                      </td>
                      <!-- "
                      :disabled="item.isActive==1?true:false"-->
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>

            <div
              class="mt-1 text-center"
              v-if="BLRaised.fclBlId!='' || (validateContainerSplit==true && allData[0].typeOfBL=='2')"
            >
              <b-button variant="primary" @click="proceedAws">Save & Proceed to AMS Filling</b-button>
              <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="note-modal"
      hide-footer
      :title="noteModal.creditDebitNoteType=='1'?'CREDIT NOTE':'DEBIT NOTE'"
    >
      <div class="d-block text-center">
        <!-- <h3> {{noteModal.creditDebitNoteType=='1'?'CREDIT NOTE':'DEBIT NOTE'}}</h3><br> -->
        <h4
          class="error"
        >{{noteModal.approvalStatus=='1'?'Approved':noteModal.sentForApproval=='1'?'Sent for approval':'' }}</h4>
      </div>
      <!-- <md-layout md-gutter class="mt-3">
          <md-layout md-flex="30">
            <label for="blType">Type</label>
            <model-list-select
              isDisabled
              v-model="noteModal.creditDebitNoteType"
              :list="noteList"
              option-value="nV"
              option-text="nT"
              placeholder="Select "
            ></model-list-select>
          </md-layout>

      </md-layout>-->
      <b-button
        v-if="noteModal.uploadCreditDebit != '' && noteModal.approvalStatus=='1'"
        @click="PrintNote(noteModal.uploadCreditDebit)"
        size="sm"
        variant="warning"
      >PDF</b-button>
      <!-- v-if="!noteModal.note_id" -->
      <b-button @click="addContent" size="sm">
        Add Particulars
        <i class="fa fa-plus-circle ml-1"></i>
      </b-button>
      <b-row>
        <b-col cols="2">
          <md-layout style="width:400px;">
            <label for="blType">To</label>
            <model-list-select
              :list="AgentColoaderList"
              option-value="agentName"
              option-text="agentName"
              v-model="noteModal.AgentColoader"
              placeholder="Select Agent/Coloader"
            ></model-list-select>
            <span class="error" v-if="!noteModal.AgentColoader">{{errorCDNote.AgentColoader}}</span>
            <!-- <span class="error" v-if="!BLRaised.blStage">{{errorBLRaised.blStage}}</span> -->
          </md-layout>
          <!-- <label>Date</label> -->
          <!-- :not-before="new Date()" -->
          <!-- <date-picker
                    v-model="noteModal.noteDate"
                    lang="en"
                    id="blDate"
                    name="blDate"
          ></date-picker>-->
        </b-col>
      </b-row>
      <div class="mt-4" v-for="(item,index) in noteParticulars" :key="index">
        <b-row>
          <b-col cols="8">
            <label for="jj">Particular</label>
            <b-form-input
              :formatter="capitalizeAll"
              v-model="item.parti"
              placeholder="Enter Particular"
            ></b-form-input>
          </b-col>
          <b-col cols="2">
            <label for="jju">Amount</label>
            <b-form-input
              :formatter="capitalizeAll"
              v-model="item.amt"
              type="number"
              placeholder="Enter Amount"
            ></b-form-input>
          </b-col>
          <b-button
            class="pull-right"
            style="margin-top:38px"
            v-if="index>0"
            size="sm"
            @click="removeParti(index)"
          >
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
          </b-button>
        </b-row>
      </div>
      <b-row class="mt-2">
        <b-col>
          <label for="jj">Remarks</label>
          <b-form-textarea :formatter="capitalizeAll" v-model="noteModal.remarks"></b-form-textarea>
        </b-col>
      </b-row>
      <!-- v-if="!noteModal.note_id" -->
      <b-button
        class="mt-3"
        variant="success"
        v-if="noteParticulars.length>0 && ShowSendApproval==true"
        block
        @click="submitNote"
      >Send for approval</b-button>
      <b-button class="mt-5" variant="outline-danger" block @click="hideNoteModal">Close</b-button>
    </b-modal>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="pre-alert-modal"
      hide-footer
      title="FCL Export BL Pre Alert"
    >
      <b-row>
        <!-- <b-col cols="9"> 
            <div class="d-block text-center">
          <h3>FCL Export BL Pre Alert</h3><br>
          </div>
        </b-col>-->
        <b-col cols="3">
          <b-button
            v-if="preAlertData.fclAlertId != '' && allData[0].billingType!='1'"
            @click="sendMANIFESTATION"
            size="sm"
            variant="warning"
            style="margin-left: 5px"
          >SEND MANIFESTATION DETAILS</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-2">
         <b-col cols="6">
          <label for="jj">AGENT REFERENCE ID</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.agent_reference_id"
            placeholder="VESSEL & VOY"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">SHIPPING LINE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shippingLine"
            placeholder="SHIPPING LINE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">SHIPMENT TYPE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shipmentType"
            placeholder="SHIPMENT TYPE"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6">
          <!-- <label for="jj">SHIPPER NAME</label>  -->
          <label for="jj">Consignor</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shipper_name"
            placeholder="Consignor"
          ></b-form-input>
        </b-col>

        <!-- </b-row>
        <b-row class="mt-2">-->

        <b-col cols="6">
          <label for="jj">LOAD PORT</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.portLoad"
            placeholder="LOAD PORT"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
         <b-col cols="6">
          <label for="jj">POD</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.portDischarge"
            placeholder="POD"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">Final PLACE OF DELIVERY</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.placeDilievery"
            placeholder="Final PLACE OF DELIVERY"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">CONTAINER NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.container_no"
            placeholder="CONTAINER NO."
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">HOUSE BL NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.house_bl_no"
            placeholder="HOUSE BL NO."
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">MASTER BL NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.master_bl_no"
            placeholder="MASTER BL NO."
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">VESSEL & VOY</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.vesselVoy"
            placeholder="VESSEL & VOY"
          ></b-form-input>
        </b-col>
        
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">ETD / SOB DATE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.etd_date"
            placeholder="ETD / SOB DATE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">ETA DISCHARGE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.eta_date"
            placeholder="ETA DISCHARGE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="deliveryTerms">Delivery Terms(INCOTERMS)<span class="error">*</span></label>
            <model-list-select
              :list="deliveryTermsName"
              v-model="preAlertData.deliverytermmode"
              option-value="deliveryTermsVal"
              option-text="deliveryTermsText"
              placeholder="Select Delivery Terms"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.deliverytermmode}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.deliverytermmode=='ExWorks' || preAlertData.deliverytermmode=='DAP' || preAlertData.deliverytermmode=='DDP' || preAlertData.deliverytermmode=='FCA' || preAlertData.deliverytermmode=='FOB' || preAlertData.deliverytermmode=='CIF' || preAlertData.deliverytermmode=='CFR'">
            <label for="blType">Handling Agent<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
              option-value="value"
              option-text="text"
              v-model="preAlertData.handling_agent"
              placeholder="Select Handling Agent"
              @input="getAgentDeatils(preAlertData.handling_agent,'handling_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.handling_agent}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.deliverytermmode=='ExWorks' || preAlertData.deliverytermmode=='DAP' || preAlertData.deliverytermmode=='DDP' || preAlertData.deliverytermmode=='FCA'">
            <label for="blType">Clearing Agent<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
              option-value="value"
              option-text="text"
              v-model="preAlertData.clearing_agent"
              placeholder="Select Clearing Agent"
              
              @input="getAgentDeatils(preAlertData.clearing_agent,'clearing_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.clearing_agent}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.deliverytermmode=='ExWorks' || preAlertData.deliverytermmode=='DAP' || preAlertData.deliverytermmode=='DDP' || preAlertData.deliverytermmode=='FCA'">
            <label for="blType">Destination Door Delivery By:<span class="error">*</span></label>
            <model-list-select
            :list="invCategoryList"
              option-value="payVal"
              option-text="payText"
              v-model="preAlertData.delivery_agent"
              placeholder="Select Destination Door Delivery By"
              
              @input="getAgentDeatils(preAlertData.delivery_agent,'delivery_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.delivery_agent}}</span>
        </b-col>
        <!-- <b-col md="6">
          <label>Agent/Shippine Line<span class="error">*</span></label>
          <b-form-radio-group
            v-model="preAlertData.agent_type"
            :options="invCategoryList"
            class="mb-3"
            value-field="payVal"
            text-field="payText"
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </b-col> -->
        <b-col cols="6" v-if="preAlertData.delivery_agent=='Agent'">
            <label for="blType">Agent<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
              option-value="value"
              option-text="text"
              v-model="preAlertData.agent_type_agent"
              placeholder="Select Agent"
              
              @input="getAgentDeatils(preAlertData.agent_type_agent,'agent_type_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.agent_type_agent}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.delivery_agent=='Shipping Line'">
            <label for="blType">Shipping Line<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['common/getAllShippingLineList']"
              v-model="preAlertData.agent_type_sline"
              option-value="shippingId"
              option-text="shippingLine"
              placeholder="Select Shipping Line"
              
              @input="getAgentDeatils(preAlertData.agent_type_sline,'agent_type_sline')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.agent_type_sline}}</span>
        </b-col>
        <b-col cols="6">
          <label for="frghtTermsHbl">Shipping Line Charges<span class="error">*</span></label>
          <model-list-select
            :list="frghtTermsHblListName"
            v-model="preAlertData.sline_charges"
            option-value="frghtTermsHblVal"
            option-text="frghtTermsHblTxt"
            placeholder="Select Shipping Line Charges"
          ></model-list-select>
          <span class="error">{{errorCustomValidation.sline_charges}}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <label for="jj">CONSIGNEE</label>
          <!-- <b-form-input :formatter="capitalizeAll"  placeholder="CONSIGNEE"  ></b-form-input> -->
          <b-form-textarea :formatter="capitalizeAll" v-model="preAlertData.consignee"></b-form-textarea>
        </b-col>
        <b-col cols="6">
          <label for="jj">OVERSEAS AGENT</label>
          <!-- <b-form-input :formatter="capitalizeAll"   placeholder="OVERSEAS AGENT"  ></b-form-input> -->
          <b-form-textarea :formatter="capitalizeAll" v-model="preAlertData.delieveryAgent"></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="my-4">
        <!-- <md-layout md-flex="5"></md-layout> -->
        <b-col cols="6">
          <md-input-container>
            <label>Upload Master BL</label>
            <md-file
              placeholder="Click to Upload Master BL"
              name="masterUpload"
              id="masterUpload"
              v-model="preAlertData.masterBlUpload"
              @selected="onFileChangeBlDraft('masterBl')"
              multiple
            ></md-file>
          </md-input-container>
          <b
            v-if="preAlertData.masterBlUpload!=''&&preAlertData.masterBlUpload!=undefined&&preAlertData.masterBlUpload!=null"
          >
            <span
              v-for="(item_MB_doc, index_MB_doc) in preAlertData.masterBlUpload.split(',')"
              :key="index_MB_doc"
            >
              <a
                v-if="item_MB_doc !=''"
                href="javascript:void(0)"
                @click="Print(item_MB_doc)"
              >View Document - {{ index_MB_doc + 1 }}</a>
              <br />
            </span>
          </b>
        </b-col>
        <!-- <md-layout md-flex="5"></md-layout> -->
        <b-col cols="6">
          <md-input-container>
            <label>Upload House BL</label>
            <md-file
              placeholder="Click to Upload House Bl"
              name="houseUpload"
              id="houseUpload"
              v-model="preAlertData.houseBlUpload"
              @selected="onFileChangeBlDraft('houseBl')"
              multiple
            ></md-file>
          </md-input-container>
          <b
            v-if="preAlertData.houseBlUpload!=''&&preAlertData.houseBlUpload!=undefined&&preAlertData.houseBlUpload!=null"
          >
            <span
              v-for="(item_HB_doc, index_HB_doc) in preAlertData.houseBlUpload.split(',')"
              :key="index_HB_doc"
            >
              <a
                v-if="item_HB_doc !=''"
                href="javascript:void(0)"
                @click="Print(item_HB_doc)"
              >View Document - {{ index_HB_doc+ 1 }}</a>
              <br />
            </span>
          </b>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-button
          :disabled="(preAlertData.condition)"
          variant="success"
          @click="submitPreAlert"
        >Send Pre request</b-button>
        <!-- :disabled="(!preAlertData.masterBlUpload || !preAlertData.houseBlUpload)?true:false" -->
        <b-button class="ml-2" variant="outline-danger" @click="hidePreAlert">Close</b-button>
      </b-row>
    </b-modal>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop6"
      @close="deleteDataSplit"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseDelete"
      ref="addPopDelete"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendPreAlertMail"
      ref="popMail"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="openPreAlert"
      ref="popBlStageMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendBLApprovalMail"
      ref="popBLMail"
    ></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="popMailAfter"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import PrealertMail from "../common/prealertMail.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import CommonService from "../../services/CommonService.js";

export default {
  beforeMount() {
    this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
    this.$sessionsStorage.set("sendManifest_ffType", "");
    if (
      globalPermissionStatus("Sea Freight") ||
      globalPermissionStatus("Overseas Agent Assignments")
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/BL-US");
      this.$store.dispatch(
      "commonDropdownMaster/setAllAgentDDList",
      JSON.stringify({
        itemCode: "getAgentDDList",
        type: "Normal",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      blTableArray: [],
      sentAdditionalBL: 0, // 1:send,0:Not-Send,2:Approve,3:Reject

      savegenerateblprealertStatus: false,
      isBlSubmited: false,
      fclConId: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      visible: true,
      trackingId: "",
      deleteItem: {},
      AgentColoaderList: [],
      content: `<h2 class="ql-align-center"><span class="ql-font-serif">sajnsajknsakjnask content loading..</span></h2>`,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      containerNoName: [],
      selectAllContainers: false,
      isIndeterminate: false,
      activateIndex: [],
      creditDebitNoteData: [],
      noteParticulars: [],
      weightUnit: "",
      noteModal: {
        creditDebitNoteType: "",
        remarks: "",
        AgentColoader: "",
        noteDate: "",
        note_id: "",
        noteContent: "",
        noteAmount: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: ""
      },

      preAlertData: {
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        vesselVoy: "",
        agent_reference_id:"",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        consignee: "",
        delieveryAgent: "",
        shipmentType: "fcl",
        etd_date: "",
        eta_date: "",
        house_bl_no: "",
        master_bl_no: "",
        container_no: "",
        shippingLine: "",
        shipper_name: "",
        masterBlUpload: "",
        houseBlUpload: "",
        masterBlUpload_btn: "",
        houseBlUpload_btn: "",
        masterBlUpload_flag: false,
        houseBlUpload_flag: false,
        condition: true,
        deliverytermmode:"",
        handling_agent:"",
        handling_agent_text:"",
        clearing_agent:"",
        clearing_agent_text:"",
        delivery_agent:"",
        delivery_agent_text:"",
        agent_type:"",
        agent_type_agent:"",
        agent_type_agent_text:"",
        agent_type_sline:"",
        agent_type_sline_text:"",
        sline_charges:"",
      },
      prevBlStage: "",
      BLRaised: {
        selected_container:"",
        CreatedBY:"",
        CreatedDate:"",
        UpdatedBY:"",
        UpdatedDate:"",
        blDate: "",
        blCreatedDate: "",
        branchName: "",
        ffExportFclSeries: "",
        fclBlId: "",
        uploadBL: "",
        blStage: "",
        consignor: "",
        consignee: "",
        shippingReferenceNum: "",
        typeMove: "",

        notifyList: [
          {
            inputValue: "",
            text: ""
          },
          {
            inputValue: "",
            text: "Second"
          }
        ],
        preCarriage: "",

        billLading: "",

        vesselVoy: "",
        agent_reference_id: "",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        // containerMarks: "",
        // noPkg: "",
        descriptionGood: "",
        // grossWeight: "",
        // netWeight: "",
        // measurement: "",
        desCharges: "",
        prepaid: "",
        collect: "",
        placeBranch: "",
        delieveryAgent: "",
        agentAddress: "",
        forwarderName: "",
        forwarderContact: "",
        forwarderEmail: "",
        forwarderAddress: "",

        agentName: "",
        agentContact: "",
        agentEmail: "",
        total: "",
        portLocationType: "USA",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        bookingNo: "",

        SCAC: "",
        exportReference: "",
        consolidationNO: "",
        forwardingAgent: "",
        pointofOrigin: "",
        placeReceipt: "",
        loadingPreTerminal: "",
        reference: "",
        isConsolidation: 0,
        assignmentNo: ""
      },
      frghtTermsHblListName: [
        {
          frghtTermsHblVal: "Prepaid",
          frghtTermsHblTxt: "Prepaid",
        },
        {
          frghtTermsHblVal: "Collect",
          frghtTermsHblTxt: "Collect",
        },
      ],
      invCategoryList: [
        {
          payVal: "Agent",
          payText: "Agent",
          notEnabled: false,
        },
        {
          payVal: "Shipping Line",
          payText: "Shipping Line",
          notEnabled: false,
        },
      ],
      errorCustomValidation: {
        deliverytermmode: "",
        handling_agent: "",
        clearing_agent: "",
        delivery_agent: "",
        agent_type_agent: "",
        agent_type_sline: "",
        sline_charges:"",
      },
      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "ExWorks",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],
      errorBLRaised: {
        blDate: "",
        blStage: ""
        // consignor: "",
        // consignee: "",
        // shippingReferenceNum: "",
        // typeMove: "",

        // preCarriage: "",

        // billLading: "",
        // vesselVoy: "",
        // portLoad: "",
        // portDischarge: "",
        // placeDilievery: "",
        // // containerMarks: "",
        // // noPkg: "",
        // descriptionGood: "",
        // // grossWeight: "",
        // // netWeight: "",
        // // measurement: "",
        // desCharges: "",
        // prepaid: "",
        // collect: "",
        // placeBranch: "",
        // delieveryAgent: "",
        // total: "",
        // bookingNo: "",
        // SCAC: "",
        // exportReference: "",
        // consolidationNO: "",
        // forwardingAgent: "",
        // pointofOrigin: "",
        // placeReceipt: "",
        // loadingPreTerminal: "",
        // reference: ""
      },

      arrayErrorBLRaised: [
        {
          blDate: "Please Enter BL Date",
          blStage: "Please Select BL Stage"
          // consignor: "Please Enter Consignor",
          // consignee: "Please Enter Consignee",
          // shippingReferenceNum: "Please Enter Shipping Reference",
          // typeMove: "Please Enter Type Move",

          // preCarriage: "Please Enter Pre Carriage",

          // billLading: "Please Enter Bill Lading No",

          // vesselVoy: "Please Enter Vessel Voy",
          // portLoad: "Please Enter Port Load",
          // portDischarge: "Please Enter Port Discharge",
          // placeDilievery: "Please Enter Place Delievery",
          // // containerMarks: "Please Enter Container Marks",
          // // noPkg: "Please Enter No of Package",
          // descriptionGood: "Please Enter Description Good",
          // // grossWeight: "Please Enter Gross Weight",
          // // netWeight: "Please Enter Net Weight",
          // // measurement: "Please Enter Measurement",
          // desCharges: "Please Enter Description Charges",
          // prepaid: "Please Enter Prepaid",
          // collect: "Please Enter Collect",
          // placeBranch: "Please Enter Branch",
          // delieveryAgent: "Please Select Delievery Agent",
          // total: "Please Enter Total",
          // bookingNo: "Enter Booking No",
          // SCAC: "Enter SCAC",
          // exportReference: "Enter Export Reference ",
          // consolidationNO: "Enter Consolidation Number",
          // forwardingAgent: "Select Agent",
          // pointofOrigin: "Enter Point of Origin",
          // placeReceipt: "Enter Place of Receipt",
          // loadingPreTerminal: "Enter Loading Terminal",
          // reference: "Enter References"
        }
      ],
      errorCDNote: {
        AgentColoader: ""
      },
      arrayErrorCDNote: [
        {
          AgentColoader: "Please Select To"
        }
      ],

      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight"
      ],
      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth"
      ],

      blStageList: [
        {
          blStageVal: "DRAFT",
          blStageTxt: "DRAFT"
        },
        {
          blStageVal: "NON-NEGOTIABLE",
          blStageTxt: "Non/­Negotiable"
        },
        {
          blStageVal: "ORIGINAL",
          blStageTxt: "ORIGINAL"
        },

        {
          blStageVal: "SEAWAY",
          blStageTxt: "SEAWAY"
        }
      ],
      blStageListAfterOriginalCreated: [
        {
          blStageVal: "SEAWAY",
          blStageTxt: "SEAWAY"
        }
      ],
      originalDone: false,
      containerTypeDetailFactory: [],
      pridelBranchLocation: [],

      PlaceList: [
        {
          PlaceVal: "Delhi",
          PlaceTxt: "Delhi"
        },
        {
          PlaceVal: "Jaipur",
          PlaceTxt: "Jaipur"
        }
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      AgentList: [],
      allData: [
        {
          typeOfBL: ""
        }
      ],
      paylod: [
        {
          tableName: "frght_bllanding",
          tableId: "ffExportFclId",
          tableVal: this.$sessionsStorage.get("editExportFCLId")
        },
        {
          tableName: "fcl_bl_raised",
          tableId: "ffExportFclId",
          tableVal: this.$sessionsStorage.get("editExportFCLId")
        }
      ],
      paylodUpdate: {
        splitBlList: [],
        typeOfBL: ""
      },
      BLDetailsList: [],
      validate: true,
      errorIdName: "",
      splitContainer: [],
      splitBlList: [],
      validateContainerSplit: true,
      prealertDetails: [],
      timer: null,
      countdown: 30, // Set the initial countdown time
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  watch: {
    BLRaised: {
      handler: function(newVal, oldVal) {
        if (this.BLRaised.notifyList) {
          for (let i = 0; i < this.BLRaised.notifyList.length; i++) {
            let noti = this.BLRaised.notifyList[i].inputValue;
            let result3 = noti.replaceAll("&nbsp;", " ");
            this.BLRaised.notifyList[i].inputValue = result3;
          }
          console.log(this.BLRaised.notifyList, "j");
        }

        if (this.BLRaised.consignee) {
          let consine = this.BLRaised.consignee;
          let result1 = consine.replaceAll("&nbsp;", " ");
          this.BLRaised.consignee = result1;
        }
        if (this.BLRaised.consignor) {
          let consinr = this.BLRaised.consignor;
          let result2 = consinr.replaceAll("&nbsp;", " ");
          this.BLRaised.consignor = result2;
        }
        if (this.BLRaised.descriptionGood) {
          let blRaised = this.BLRaised.descriptionGood;
          let result = blRaised.replaceAll("<p><br></p>", "");
          let result6 = blRaised.replaceAll("&nbsp;", " ");
          // console.log(result,"test")
          this.BLRaised.descriptionGood = result6;
        }

        if (this.BLRaised.placeBranch != "") {
          this.getBranchName();
        }
        if (this.BLRaised.delieveryAgent != "") {
          this.getAgentName();
        }

        if (this.BLRaised.forwardingAgent != "") {
          this.getForwardAgentName();
        }
      },
      deep: true
    }
  },
  mounted() {},

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    BannerComponent,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    PrealertMail
  },

  computed: {
    containerNoList() {
      return this.containerNoName;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    },
    isButtonDisabled() {
      return (this.savegenerateblprealertStatus || this.isBlSubmited || this.timer !== null);
    },
    
     // Container selection computed properties
     selectedContainersCount() {
      return this.getSelectedContainers().length;
    },
    selectableContainersCount() {
      return this.containerTypeDetailFactory.filter(item => item.containerWithSplit != 1).length;
    },
    hasSelectedContainers() {
      return this.selectedContainersCount > 0;
    },
    allContainersSelected() {
      return this.selectedContainersCount === this.selectableContainersCount && this.selectableContainersCount > 0;
    }
  },

  methods: {
     // Method to validate container selection
     validateContainerSelection() {
      const selectedContainers = this.getSelectedContainers();
      if (selectedContainers.length === 0) {
        this.alert.content = "Please select at least one container to proceed";
        this.$refs["addPop"].open();
        return false;
      }
      return true;
    },
       // Container selection methods
       toggleSelectAll() {
      this.containerTypeDetailFactory.forEach(item => {
        if (item.containerWithSplit != 1) {
          item.selected = this.selectAllContainers;
        }
      });
      this.updateSelectAll();
    },
    
    updateSelectAll() {
      const selectableContainers = this.containerTypeDetailFactory.filter(item => item.containerWithSplit != 1);
      const selectedContainers = selectableContainers.filter(item => item.selected);
      
      if (selectedContainers.length === 0) {
        this.selectAllContainers = false;
        this.isIndeterminate = false;
      } else if (selectedContainers.length === selectableContainers.length) {
        this.selectAllContainers = true;
        this.isIndeterminate = false;
      } else {
        this.selectAllContainers = false;
        this.isIndeterminate = true;
      }
    },
    
    getSelectedContainers() {
      return this.containerTypeDetailFactory.filter(item => item.selected);
    },
    
    getSelectedContainersMinimal() {
      return this.containerTypeDetailFactory
        .filter(item => item.selected)
        .map(item => ({
          uniqueContainerId: item.ffExecutionContainerId,
          containerNo: item.containerNo
        }));
    },
    
    getSelectedContainerIds() {
      return this.getSelectedContainers().map(item => item.ffExecutionContainerId);
    },
    
    getSelectedContainerNumbers() {
      return this.getSelectedContainers().map(item => item.containerNo);
    },

    
    // Method to select a single container by container number
    selectContainerByNumber(containerNumber) {
      const container = this.containerTypeDetailFactory.find(item => item.containerNo === containerNumber);
      if (container && container.containerWithSplit != 1) {
        container.selected = true;
        this.updateSelectAll();
      }
    },
    
    // Method to deselect a single container by container number
    deselectContainerByNumber(containerNumber) {
      const container = this.containerTypeDetailFactory.find(item => item.containerNo === containerNumber);
      if (container) {
        container.selected = false;
        this.updateSelectAll();
      }
    },
    
    // Method to get containers for operations (uses selected containers if any, otherwise all containers)
    getContainersForOperation() {
      const selectedContainers = this.getSelectedContainers();
      return selectedContainers.length > 0 ? selectedContainers : this.containerTypeDetailFactory;
    },

     // Method to auto-select containers from saved data
     autoSelectContainersFromData(selectedContainerData) {
      console.log("priyanshu Singh containerIds1=>", selectedContainerData);
      console.log("priyanshu Singh containerTypeDetailFactory1=>", this.containerTypeDetailFactory);
      if (!selectedContainerData || !this.containerTypeDetailFactory.length) {
        return;
      }
     
      
      try {
        // Clear all current selections first
        this.containerTypeDetailFactory.forEach(container => {
          container.selected = false;
        });
        
        // Handle comma-separated string format (e.g., "167477, 167478, ")
        if (typeof selectedContainerData === 'string') {
          // Split by comma and clean up whitespace and empty values
          const containerIds = selectedContainerData
            .split(',')
            .map(id => id.trim())
            .filter(id => id !== '' && id !== null && id !== undefined);
            console.log("priyanshu Singh containerIds=>", containerIds);
            console.log("priyanshu Singh containerTypeDetailFactory=>", this.containerTypeDetailFactory);
          // Select containers based on uniqueContainerId
          containerIds.forEach(containerId => {
            const container = this.containerTypeDetailFactory.find(item => 
              item.uniqueContainerId == containerId
            );
            
            if (container && container.containerWithSplit != 1) {
              container.selected = true;
            }
          });
        }
        
        // Update the select all state
        this.updateSelectAll();
        
        console.log('Auto-selected containers from saved data:', selectedContainerData);
      } catch (error) {
        console.error('Error auto-selecting containers:', error);
      }
    },

    getAgentDeatils(item,key){
      let agentFilter = [];
      if(key=='handling_agent' || key=='clearing_agent' || key=='agent_type_agent'){
        agentFilter = this.$store.getters['commonDropdownMaster/getAllAgentDDList'].filter((x) => {
                          return x.value == item;
                      });
      }
      if(key=='agent_type_sline'){
        agentFilter = this.$store.getters['common/getAllShippingLineList'].filter((x) => {
                          return x.shippingId == item;
                      });
      }
      console.log("agentFilter=>",agentFilter)
      
      if(key=='handling_agent'){
        this.preAlertData.handling_agent_text=agentFilter[0].text;
      }else if(key=='clearing_agent'){
        this.preAlertData.clearing_agent_text=agentFilter[0].text;
      }else if(key=='agent_type_agent'){
        this.preAlertData.agent_type_agent_text=agentFilter[0].text;
      }else if(key=='agent_type_sline'){
        this.preAlertData.agent_type_sline_text=agentFilter[0].shippingLine;
      }
    },
    checBlstage(item) {
      // alert(item)
      if (item == "DRAFT") {
        this.savegenerateblprealertStatus = false;
      } else if (this.preAlertData.fclAlertId != "" && item != "DRAFT") {
        this.savegenerateblprealertStatus = false;
      } else {
        this.savegenerateblprealertStatus = true;
      }
      //  alert(item);
      //  alert(this.savegenerateblprealertStatus);
      if (
        this.prevBlStage == "DRAFT" &&
        this.prevBlStage != item &&
        this.savegenerateblprealertStatus == true
      ) {
        this.openPopBLStage();
      }
    },
    onFileChangeBlDraft(ID) {
      this.isLoading = true;
      this.preAlertData.condition = true;
      let files = event.target.files || event.dataTransfer.files;
      console.log(files);

      let exportfclId = this.$sessionsStorage.get("editExportFCLId");
      let allModuleId = this.$sessionsStorage.get("editSalesExId");
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "masterBl") {
          this.preAlertData.masterBlUpload_flag = true;
          formData.append(
            "staticFileName",
            "Sea_Export_MasterBL_" + allModuleId
          );
        } else if (ID == "houseBl") {
          this.preAlertData.houseBlUpload_flag = true;
          formData.append(
            "staticFileName",
            "Sea_Export_HouseBL_" + allModuleId
          );
        }

        formData.append(
          "upload_dir_folderName",
          // "FF_Sea_Export_Sline_Payments_Uploads"
          this.allData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }

      console.log("Upload => ", formData);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + exportfclId
        }
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then(result => {
          const { data, status, statusText } = result;

          console.log("result Upload=>", result);
          if (ID == "masterBl") {
            this.preAlertData.masterBlUpload = result.data;
            this.preAlertData.masterBlUpload_btn = result.data;
          } else {
            this.preAlertData.houseBlUpload = result.data;
            this.preAlertData.houseBlUpload_btn = result.data;
          }
          this.preAlertData.condition =
            this.preAlertData.masterBlUpload_flag &&
            this.preAlertData.houseBlUpload_flag
              ? this.preAlertData.masterBlUpload_btn &&
                this.preAlertData.houseBlUpload_btn
                ? false
                : true
              : false;
          // alert(this.preAlertData.masterBlUpload)
          this.isLoading = false;
        })
        .catch(err => {
          throw err;
        });
    },
    openPopBLMail() {
      this.alert.content = "Send Edit BL Request";
      this.$refs["popBLMail"].open();
    },
    sendBLApprovalMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let containerNoArry = [];
        this.containerTypeDetailFactory.map(x => {
          containerNoArry.push(x.containerNo);
        });

        let newData = {
          mailBLApproval: "BLApprovalMail",
          BLNO: this.BLRaised.fclBlId,
          assignmentNo: this.allData[0].ffExportFclSeries
        };
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/sendBLApproval.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;
              console.log(data);
              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.isLoading = false;
            })
            .catch(error => {});
        }
      }
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
    },
    addContent() {
      let obj = {
        parti: "",
        amt: ""
      };

      this.noteParticulars.push(obj);
    },
    openNoteModal(id) {
      this.getData();
      this.noteModal.creditDebitNoteType = id;

      if (this.creditDebitNoteData.length > 0) {
        let arrayNote = this.creditDebitNoteData.filter(x => {
          return x.creditDebitNoteType == id;
        });
        if (arrayNote.length > 0) {
          Object.keys(this.noteModal).map((x, index) => {
            this.noteModal[x] = arrayNote[0][x];
          });
          if (arrayNote[0].noteContent) {
            let dummyCont = arrayNote[0].noteContent.split(",");
            let dummyAmt = arrayNote[0].noteAmount.split(",");

            for (let i = 0; i < dummyCont.length; i++) {
              let obj = {
                parti: dummyCont[i],
                amt: dummyAmt[i]
              };

              this.noteParticulars.push(obj);
            }
          }
          if (arrayNote[0].sentForApproval == "0") {
            this.ShowSendApproval = true;
          } else {
            this.ShowSendApproval = false;
          }
        } else {
          this.ShowSendApproval = true;
        }
        // this.noteModal.note_id=this.creditDebitNoteData[0].note_id
        // this.noteModal.creditDebitNoteType=this.creditDebitNoteData[0].creditDebitNoteType
        // this.noteModal.note=this.creditDebitNoteData[0].note_id
      } else {
        this.ShowSendApproval = true;
      }
      this.$refs["note-modal"].show();
    },

    hideNoteModal() {
      Object.keys(this.noteModal).map((x, index) => {
        this.noteModal[x] = "";
      });
      this.noteParticulars = [];

      this.$refs["note-modal"].hide();
    },
    validateCDNote() {
      let validate_new = true;
      Object.keys(this.errorCDNote).map((x, index) => {
        if (this.noteModal[x] == "") {
          this.errorCDNote[x] = this.arrayErrorCDNote[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    submitNote() {
      this.validateCDNote();
      if (this.validate == false) return false;
      this.isLoading = true;
      this.ShowSendApproval = false;
      if (this.noteParticulars.length <= 0) {
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];

      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        noteAmt.push(
          this.noteParticulars[i].amt ? this.noteParticulars[i].amt : 0
        );
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      let containerNoArryNote = [];
      this.containerTypeDetailFactory.map(x => {
        containerNoArryNote.push(x.containerNo);
      });
      this.noteModal["containerNoArryNote"] = containerNoArryNote.toString();
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.allData[0].allModuleId;
      this.noteModal["agentName"] = this.BLRaised.agentName;
      this.noteModal["agentAddress"] = this.BLRaised.agentAddress;
      this.noteModal["vesselVoy"] = this.BLRaised.vesselVoy;
      this.noteModal["agent_reference_id"] = this.BLRaised.agent_reference_id;
      this.noteModal["shipper"] = this.allData[0].clientName;
      this.noteModal["consignee"] = this.BLRaised.consignee;
      this.noteModal["fclBlId"] = this.BLRaised.fclBlId;
      this.noteModal["branchName"] = this.BLRaised.branchName;
      this.noteModal["FinalPlace"] = this.BLRaised.placeDilievery;
      this.noteModal["masterorLinerBlNo"] = this.allData[0].linerBLNumber;
      this.noteModal["BLNumber"] =
        this.BLRaised.billLading +
        (this.fclConId != "" ? this.fclConId : this.BLRaised.fclBlId);

      this.noteModal["salesSeries"] = this.allData[0].ffExportFclSeries;
      this.noteModal[
        "salesSeriesUpload"
      ] = this.allData[0].ffExportFclSeries.replaceAll("/", "_");

      this.noteModal["ffExportFclId"] = this.$sessionsStorage.get(
        "editExportFCLId"
      );
      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew.php`,
          data: JSON.stringify(this.noteModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              Object.keys(this.noteModal).map(x => {
                this.noteModal[x] = "";
              });
              this.noteParticulars = [];

              this.$refs["note-modal"].hide();
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.allData[0].allModuleId
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
          }
        })
        .catch(error => {});
    },
    removeTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();

      // Regular expression to identify HTML tags in
      // the input string. Replacing the identified
      // HTML tag with a null string.
      return str.replace(/(<([^>]+)>)/gi, "");
    },

    openPreAlert() {
      this.isLoading = true;
      this.preAlertData.handling_agent =this.allData[0].delieveryAgent;
      this.preAlertData.clearing_agent =this.allData[0].delieveryAgent;
      this.preAlertData.agent_type_agent =this.allData[0].delieveryAgent;
      this.preAlertData.agent_type_sline =this.allData[0].shippingId;
      if(this.allData[0].delieveryAgent){
        let agentFilter = this.$store.getters['commonDropdownMaster/getAllAgentDDList'].filter((x) => {
                          return x.value == this.allData[0].delieveryAgent;
                      });
                      
        if(agentFilter.length>0){
          this.preAlertData.handling_agent_text =agentFilter[0].text;
          this.preAlertData.clearing_agent_text =agentFilter[0].text;
          this.preAlertData.agent_type_agent_text =agentFilter[0].text;
        }
      }
      if(this.allData[0].shippingId){

        let agentFilter = this.$store.getters['common/getAllShippingLineList'].filter((x) => {
                          return x.shippingId == this.allData[0].shippingId;
                      });
                      
          this.preAlertData.agent_type_sline_text =agentFilter[0].shippingLine;
      }
      // let data = await this.getPrealertDetails();
      if (this.allData[0].prealertDetails) {
        this.preAlertData.masterBlUpload = this.allData[0].prealertDetails.masterBlUpload;
        this.preAlertData.houseBlUpload = this.allData[0].prealertDetails.houseBlUpload;

        this.preAlertData.deliverytermmode = this.allData[0].prealertDetails.deliverytermmode;
        this.preAlertData.handling_agent = this.allData[0].prealertDetails.handling_agent;
        this.preAlertData.handling_agent_text = this.allData[0].prealertDetails.handling_agent_text;
        this.preAlertData.clearing_agent = this.allData[0].prealertDetails.clearing_agent;
        this.preAlertData.clearing_agent_text = this.allData[0].prealertDetails.clearing_agent_text;
        this.preAlertData.delivery_agent = this.allData[0].prealertDetails.delivery_agent;
        this.preAlertData.delivery_agent_text = this.allData[0].prealertDetails.delivery_agent_text;
        this.preAlertData.agent_type = this.allData[0].prealertDetails.agent_type;
        this.preAlertData.agent_type_agent = this.allData[0].prealertDetails.agent_type_agent;
        this.preAlertData.agent_type_agent_text = this.allData[0].prealertDetails.agent_type_agent_text;
        this.preAlertData.agent_type_sline = this.allData[0].prealertDetails.agent_type_sline;
        this.preAlertData.agent_type_sline_text = this.allData[0].prealertDetails.agent_type_sline_text;
        this.preAlertData.etd_date = this.allData[0].prealertDetails.etd_date;
        this.preAlertData.eta_date = this.allData[0].prealertDetails.eta_date;
        this.preAlertData.sline_charges = this.allData[0].prealertDetails.sline_charges;
      }
      
      console.log("prealertDetails=>", this.prealertDetails);

      let containerNoArryNote = [];
      this.containerTypeDetailFactory.map(x => {
        containerNoArryNote.push(x.containerNo);
      });

      this.preAlertData["container_no"] = containerNoArryNote.toString();
      this.preAlertData["allModuleId"] = this.allData[0].allModuleId;
      this.preAlertData["shippingId"] = this.allData[0].shippingId;
      this.preAlertData["shippingLine"] = this.allData[0].shippingLine;
      this.preAlertData["delieveryAgent"] = this.BLRaised.agentName;
      this.preAlertData["agentAddress"] = this.BLRaised.agentAddress;
      this.preAlertData["agentEmail"] = this.BLRaised.agentEmail;

      this.preAlertData["vesselVoy"] = this.BLRaised.vesselVoy;
      this.preAlertData["agent_reference_id"] = this.BLRaised.agent_reference_id;
      this.preAlertData["shipper_name"] = this.allData[0].clientName;
      this.preAlertData["consignee"] = this.removeTags(this.BLRaised.consignee);
      this.preAlertData["fclBlId"] = this.BLRaised.fclBlId;
      this.preAlertData["branchName"] = this.BLRaised.branchName;
      this.preAlertData["placeDilievery"] = this.BLRaised.placeDilievery;
      this.preAlertData["portDischarge"] = this.BLRaised.portDischarge;
      this.preAlertData["portLoad"] = this.BLRaised.portLoad;
      this.preAlertData["assignmentNo"] = this.allData[0].ffExportFclSeries;
      this.preAlertData["shipmentType"] = this.allData[0].containerInfo;
      this.preAlertData[
        "ffExportFclSeries"
      ] = this.allData[0].ffExportFclSeries.replaceAll("/", "_");

      this.preAlertData["mailPreAlert"] = "1";

      this.preAlertData["master_bl_no"] = this.allData[0].linerBLNumber;
      this.preAlertData["house_bl_no"] =
        this.BLRaised.billLading +
        (this.fclConId != "" ? this.fclConId : this.BLRaised.fclBlId);

      if (this.trackingId != "") {
        let payload = {
          subscriptionId: this.trackingId
        };

        // console.log(this.$sessionsStorage.get("loginId"))

        console.log("Test => ", payload);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            this.isLoading = false;
            const { statusText, status, data } = result;

            // alert(statusText+" : "+status+" : "+data)
            if (status == 200 && data) {
              //alert(data);

              console.log("Result => ", JSON.parse(data.data));

              data.data = JSON.parse(data.data);

              // this.shippmentDetails.push(data.data);

              if (data.data.containershipments.length > 0) {
                this.preAlertData["vesselVoy"] = data.data
                  .containershipments[0]["current_vessel"]
                  ? data.data.containershipments[0]["current_vessel"]["name"]
                  : "";
                this.preAlertData["etd_date"] =
                  data.data.containershipments[0]["pol_vsldeparture_actual"] ||
                  data.data.containershipments[0][
                    "pol_vsldeparture_planned_last"
                  ];
                this.preAlertData["eta_date"] =
                  data.data.containershipments[0]["pod_vslarrival_actual"] ||
                  data.data.containershipments[0][
                    "pod_vslarrival_planned_last"
                  ];
              }
            }
          })
          .catch(error => {
            this.isLoading = false;
            console.log("Err => ", error);
          });
      }

      this.isLoading = false;

      this.$refs["pre-alert-modal"].show();
    },

    getPrealertDetails() {
      // return new Promise(resolve => {
      let payload = {
        allModuleId: this.allData[0].allModuleId,
        itemCode: "GET_PreAlert_Data",
        itemtype: "FCL"
      };
      payload = JSON.stringify(payload);
      CommonService.getAllPreAlertDetails(payload)
        .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log("Data Found", data.PreAlert_Data.length);
            if (data.PreAlert_Data.length > 0) {
              this.prealertDetails = data.PreAlert_Data;
            }
          } else {
            console.log("Data Not Found");
          }
          this.isLoading = false;
          // return resolve(status == 200);
        })
        .catch(error => {
          console.log("Catch on Overseas_Agent_SOA Error: ", error);
        });
      // });
    },

    hidePreAlert() {
      this.$refs["pre-alert-modal"].hide();
      if (this.savegenerateblprealertStatus == true) {
        this.openPopensureprealert();
      }
    },
    sendMANIFESTATION() {
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffType", "");
      this.$forceUpdate();
      this.$sessionsStorage.set("sendManifest_ffType", "FF Export");
      this.$sessionsStorage.set(
        "sendManifest_ffFclallModuleId",
        this.allData[0].allModuleId
      );
      this.$sessionsStorage.set(
        "sendManifest_ffExportFclId",
        this.preAlertData.ffExportFclId
      );

      this.$router.push({
        path: "/freightForwarding/sendManifestation"
      });
    },
    submitPreAlert() {
      Object.keys(this.errorCustomValidation).map((x, index) => {
        this.errorCustomValidation[x] = "";
      });
      if(!this.preAlertData.deliverytermmode){
        this.errorCustomValidation.deliverytermmode = "Please Select Delivery Terms(INCOTERMS)";
        return false;
      }
      if(!this.preAlertData.sline_charges){
        this.errorCustomValidation.sline_charges = "Please Select Shipping Line Charges";
        return false;
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA' || this.preAlertData.deliverytermmode=='FOB' || this.preAlertData.deliverytermmode=='CIF' || this.preAlertData.deliverytermmode=='CFR'){
        if(!this.preAlertData.handling_agent){
          this.errorCustomValidation.handling_agent = "Please Select Handling Agent";
          return false;
        }
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA'){
        if(!this.preAlertData.clearing_agent){
          this.errorCustomValidation.clearing_agent = "Please Select Clearing Agent";
          return false;
        }
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA'){
        if(!this.preAlertData.delivery_agent){
          this.errorCustomValidation.delivery_agent = "Please Select Delivery Agent";
          return false;
        }
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA'){
        if(this.preAlertData.delivery_agent=='Agent' && !this.preAlertData.agent_type_agent){
          this.errorCustomValidation.agent_type_agent = "Please Select Agent";
          return false;
        }
        if(this.preAlertData.delivery_agent=='Shipping Line' && !this.preAlertData.agent_type_sline){
          this.errorCustomValidation.agent_type_sline = "Please Select Shipping Line";
          return false;
        }
      }
      this.isLoading = true;
      this.$refs["pre-alert-modal"].hide();
      let options = {
        method: "POST",
        url: `${URL_BASE}/sendPreAlertMailFclBL.php`,
        data: JSON.stringify(this.preAlertData),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          this.isLoading = false;
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Inserted Successfully") {
              this.alert.content = "Request has been sent";
            } else {
              this.alert.content = "Request has been sent";
            }
            this.savegenerateblprealertStatus = false;

            this.$refs["pre-alert-modal"].hide();
            this.$refs["addPop"].open();
          }
        })
        .catch(error => {
          this.isLoading = false;
        });

      //  this.isLoading=false
    },

    getForwardAgentName() {
      let arry2 = this.AgentList.filter(x => {
        return x.agntColoaderId == this.BLRaised.forwardingAgent;
      });
      if (arry2.length > 0) {
        this.BLRaised.forwarderName = arry2[0].agentName;
        this.BLRaised.forwarderAddress = arry2[0].address;
        this.BLRaised.forwarderEmail = arry2[0].emailId;
        this.BLRaised.forwarderContact = arry2[0].contactNumber;
      }
    },

    getAgentName() {
      let arry1 = this.AgentList.filter(x => {
        return x.agntColoaderId == this.BLRaised.delieveryAgent;
      });
      if (arry1.length > 0) {
        console.log(arry1);
        this.BLRaised.agentName = arry1[0].agentName;
        this.BLRaised.agentAddress = arry1[0].address;
        this.BLRaised.agentEmail = arry1[0].emailId;
        this.BLRaised.agentContact = arry1[0].contactNumber;
        console.log(arry1, this.BLRaised.agentName);
      }
    },
    proceedToTally() {
      this.$router.push({
        path: "/freightForward/freightInvoiceForTally"
      });
    },
    getBranchName() {
      let arry = this.pridelBranchLocation.filter(x => {
        return x.pickupId == this.BLRaised.placeBranch;
      });
      if (arry.length > 0) {
        this.BLRaised.branchName = arry[0].pickupLocation;
      }
    },
    openPopMail() {
      this.alert.content = "Send Pre-Alert ..?";
      this.$refs["popMail"].open();
    },

    openPopensureprealert() {
      this.alert.content = "Please Ensure Pre-ALert is Send";
      this.$refs["popMailAfter"].open();
      // this.$refs["popMail"].open();
    },
    openPopBLStage() {
      this.alert.content =
        "Please send Pre-Alert ... then change Bl stage from Draft ";
      this.$refs["popBlStageMail"].open();
    },

    sendPreAlertMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let containerNoArry = [];
        this.containerTypeDetailFactory.map(x => {
          containerNoArry.push(x.containerNo);
        });

        let newData = {
          mailPreAlert: "PreAlrt",
          clientName: this.allData[0].clientName,
          assignmentNo: this.allData[0].ffExportFclSeries,
          shipmentType: this.allData[0].containerInfo,
          FinalPlace: this.BLRaised.placeDilievery,
          portDischarge: this.BLRaised.portDischarge,
          consignee: this.BLRaised.consignee,
          vesselVoy: this.BLRaised.vesselVoy,
          agent_reference_id: this.BLRaised.agent_reference_id,
          containerNoArry: containerNoArry
        };

        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/sendPreAlertMailBL.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;

              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.savegenerateblprealertStatus = false;
              this.isLoading = false;
            })
            .catch(error => {});
        }
      }
    },
    deleteAllBL() {
      this.alert.content =
        "Are you sure you want to delete All   B/L  of this assignment  ?";
      this.$refs["addPopDelete"].open();
    },
    onCloseDelete(type) {
      if (type != "cancel") {
        $("#DLoader").css("display", "none");
        $("#loaderD").css("display", "block");
        if (this.allData[0].typeOfBL == "2") {
          this.paylodUpdate["splitBlList"] = this.splitBlList[0].ffExportFclId;
          this.paylodUpdate["typeOfBL"] = "2";
        }
        let newData = {
          paylodUpdate: this.paylodUpdate,
          paylod: this.paylod
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/deleteBLPermanent.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loaderD").css("display", "none");
              $("#DLoader").css("display", "block");

              this.$router.push({
                path: "/freightForward/fclBLofLanding"
              });
            }
          })
          .catch(error => {});
      }
    },
    deleteDataSplit(type) {
      if (type != "cancel") {
        // console.log(this.deleteItem);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/deleteDataSplit.php`,
          data: JSON.stringify(this.deleteItem),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },

    activateUser(item, index) {
      this.splitContainer[index] = item.ffExecutionContainerId;
    },
    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.BLRaised.notifyList.length]
      };
      this.BLRaised.notifyList.push(obj);
    },
    removeNotify(index) {
      this.BLRaised.notifyList.splice(index, 1);
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    Print(item) {
      if(!item) return;
      let key =
        "ASSIGNMENT_UPLOADS/" +
        this.allData[0].ffExportFclSeries.replaceAll("/", "_") +
        "/" +
        item;
      this.openSignedDocument(key);
    },
    PrintNote(item) {
      if(!item) return;
      let key =
        "ASSIGNMENT_UPLOADS/" +
        this.allData[0].ffExportFclSeries.replaceAll("/", "_") +
        "/" +
        item;
      this.openSignedDocument(key);
    },

    proceedAws() {
      this.$sessionsStorage.set("blType", "house");
      this.$sessionsStorage.set("ffType", "fclnormal");
      this.$router.push({
        path: "/freightForwarding/amsFilingNormal"
      });
    },
    validateBLRaised() {
      let validate_new = true;
      Object.keys(this.errorBLRaised).map((x, index) => {
        if (this.BLRaised[x] == "") {
          this.errorBLRaised[x] = this.arrayErrorBLRaised[0][x];
          this.errorIdName = x;

          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        $("#" + this.errorIdName).focus();

        this.validate = false;
      }
    },
    downloadWord(id) {
      window.location =
        `${this.URL_BASE}/Api_FFSeaExport/wordBLUs.php?id=` + id;
      // "http://13.229.240.246/pridelApiNew/Freight/wordBLUs.php?id=" + id;
      // "http://localhost:80/pridel-api/Freight/wordBLUs.php?id=" + id;
    },
    startTimerBak() {
      this.timer = setTimeout(() => {
        this.isBlSubmited = false; // Reset submission state after 30 seconds
        this.timer = null; // Clear the timer reference
      }, 30000); // 30 seconds
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.countdown -= 1; // Decrease the countdown by 1 each second

        // If countdown reaches zero, reset the state
        if (this.countdown <= 0) {
          clearInterval(this.timer); // Clear the interval
          this.isBlSubmited = false; // Reset submission state
          this.timer = null; // Clear the timer reference
        }
      }, 1000); // Update every second
    },
    addBLRaised(id) {
      // if(this.prevBlStage == "DRAFT" && this.prevBlStage != this.BLRaised.blStage)
      // {
      //   this.openPopBLStage();
      // }
      console.log("priyanshu Singh=>", this.getSelectedContainersMinimal());
      // return;
      this.BLRaised["selectedContainersData"] = this.getSelectedContainers();
      this.BLRaised["allModuleId"] = this.allData[0].allModuleId;
      this.BLRaised["isPreview"] = id;

      this.BLRaised["assignmentNo"] = this.BLRaised["salesSeries"];

      this.BLRaised[
        "salesSeries"
      ] = this.allData[0].ffExportFclSeries.replaceAll("/", "_");
      this.BLRaised["ffExportFclId"] = this.$sessionsStorage.get(
        "editExportFCLId"
      );
      this.BLRaised["ffExecutionId"] = this.$sessionsStorage.get(
        "editFFExecutionId"
      );
      this.BLRaised["clientName"] = this.allData[0].clientName;

      let array = [];

      if (
        this.allData[0].typeOfBL == "2" &&
        this.splitContainer.length > 0 &&
        this.validateContainerSplit == false &&
        this.BLRaised.fclBlId == ""
      ) {
        this.activateIndex.map((x, index) => {
          if (x == true) {
            if (
              this.splitContainer[index] != "" &&
              this.splitContainer[index] != undefined &&
              this.splitContainer[index] != null
            ) {
              array.push(this.splitContainer[index]);
            }
          }
        });
      } else {
        array = this.containerTypeDetailFactory;
      }

      if (
        this.allData[0].typeOfBL == "2" &&
        array.length == 0 &&
        this.validateContainerSplit == false &&
        this.BLRaised.fclBlId == ""
      ) {
        this.alert.content = "Select atleast one container";
        this.$refs["addPop"].open();
        return false;
      }
      if (!this.validateContainerSelection()) {
        return false;
      }
      if (this.allData[0].typeOfBL == "2") {
        this.BLRaised[
          "containerDetail"
        ] = this.containerTypeDetailFactory.filter(x => {
          return array.indexOf(x.ffExecutionContainerId) >= 0;
        });
      } else {
        this.BLRaised["containerDetail"] = this.containerTypeDetailFactory;
      }
      this.BLRaised["typeOfBL"] = this.allData[0].typeOfBL;
      this.BLRaised["containerDetailStatus"] = array;

      this.BLRaised["ffBookingId"] = this.$sessionsStorage.get("ffBookingId");
      this.BLRaised["portLocationType"] = "USA";

      this.BLRaised["weightUnit"] = this.weightUnit;
      // console.log(this.BLRaised);
      // return false;
      this.validateBLRaised();

      if (this.validate != false) {
        this.isBlSubmited=true;
        this.countdown = 30; // Reset the countdown
        // Start the timer
      this.startTimer();
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addBLRaisedUs.php`,
          data: JSON.stringify(this.BLRaised),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.isBlSubmited=false;
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.BLRaised.fclBlId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }
              this.$refs["addPop"].open();

              if (this.allData[0].typeOfBL == "2") {
                this.splitContainer = [];
                Object.keys(this.BLRaised).map(x => {
                  this.BLRaised[x] = "";
                });
              }

              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },
    editBLRaised(item) {
      this.BLRaised.notifyList = [];
      Object.keys(item).map(x => {
        if (x == "notifyList") {
          item[x].split("$$$").map((y, index) => {
            let obj = {
              inputValue: y,
              text: this.notifyListArray[index]
            };

            this.BLRaised.notifyList.push(obj);
          });
        } else {
          this.BLRaised[x] = item[x] || "";
        }
      });
    },
    getAgentColoaderList() {
      let type_Size = {
        view: "jdjd"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/getAgentColoaderList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options).then(result => {
        const { statusText, status, data } = result;
        if (status == 200 && data) {
          this.AgentColoaderList = data.agentColoaderList;
        }
      });
    },
    AddMoreBL() {
      this.isLoading = true;
      let containerNoArry = [];
      this.containerTypeDetailFactory.map(x => {
        containerNoArry.push(x.containerNo);
      });

      let newData = {
        mailPreAlert: "AddMoreFCLBL",
        allModuleId: this.allData[0].allModuleId,
        clientName: this.allData[0].clientName,
        shippingLine: this.allData[0].shippingLine,
        overseasClient: this.BLRaised.agentName,
        assignmentNo: this.allData[0].ffExportFclSeries,
        shipmentType: this.allData[0].containerInfo,
        FinalPlace: this.BLRaised.placeDilievery,
        consignee: this.BLRaised.consignee,
        vesselVoy: this.BLRaised.vesselVoy,
        agent_reference_id: this.BLRaised.agent_reference_id,
        containerNoArry: containerNoArry,
        ffExportFclId: this.allData[0].ffExportFclId,
        sentAdditionalBL: "1",
        house_BLNumber: this.allData[0].house_BLNumber,
        master_linerBLNumber: this.allData[0].master_linerBLNumber
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/additionalBLRequest.php`,
        data: JSON.stringify(newData),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (data.find == 1) {
            this.alert.content = data.MSGTXT;
          } else {
            this.alert.content = data.MSGTXT;
          }
          this.$refs["popMailAfter"].open();
          this.isLoading = false;
        })
        .catch(error => {});
    },
    getData() {
      this.doLoading();
      let type_Size = {
        itemCode: "itemCode",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        fclBlId: this.$sessionsStorage.get("editfclBlId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewFCLBLNonUS_NewV3_VP.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("Priyanshu Singh=>", data);
            if (data.fclConId) {
              this.fclConId = data.fclConId;
            }
            if (data.pridelBranchLocation.length > 0) {
              this.pridelBranchLocation = data.pridelBranchLocation;
            }
            if (data.creditDebitNoteData.length > 0) {
              this.creditDebitNoteData = data.creditDebitNoteData;
            }
            console.log(data);
            if (data.ffExecutionDetailContainer.length > 0) {
              this.containerTypeDetailFactory = data.ffExecutionDetailContainer;
              this.weightUnit = data.ffExecutionDetailContainer[0].weightUnit;

              data.ffExecutionDetailContainer.map((x, index) => {
                this.activateIndex[index] =
                  x.containerWithSplit == 1 ? true : false;
              });
            }

            let arrayNew = this.activateIndex.filter(x => {
              return x == false;
            });
            if (arrayNew.length > 0) {
              this.validateContainerSplit = false;
            } else {
              this.validateContainerSplit = true;
            }
            if (data.stuffingData.length > 0) {
              this.allData = data.stuffingData;
              if (this.allData.length > 0) {
                // this.getPrealertDetails();
              }

              this.preAlertData["ffExportFclId"] =
                data.stuffingData[0].ffExportFclId;
              this.preAlertData["fclAlertId"] = data.stuffingData[0].fclAlertId;
              // alert(this.preAlertData["fclAlertId"]);
              this.sentAdditionalBL = data.stuffingData[0].sentAdditionalBL;
            }

            this.BLRaised.billLading =
              data.UserData[0].BranchCode +
              data.stuffingData[0].portCode.replace(/\s+/g, "");
            // +
            // "-" +
            // data.stuffingData[0].blLandingId;

            if (data.agentList.length > 0) {
              this.AgentList = data.agentList;
            }

            if (
              data.BLNonData.length > 0 &&
              data.stuffingData[0].typeOfBL != "2"
            ) {
              this.splitBlList = [];
              this.BLRaised.notifyList = [];
              Object.keys(this.BLRaised).map(x => {
                if (x == "notifyList") {
                  data.BLNonData[0][x].split("$$$").map((y, index) => {
                    let obj = {
                      inputValue: y,
                      text: this.notifyListArray[index]
                    };

                    this.BLRaised.notifyList.push(obj);
                  });
                } else {
                  this.BLRaised[x] = data.BLNonData[0][x] || "";
                }
              });
            } else if (
              data.BLNonData.length > 0 &&
              data.stuffingData[0].typeOfBL == "2"
            ) {
              this.splitBlList = data.BLNonData;
              this.BLRaised.consignor =
                "<p>" +
                data.stuffingData[0].clientName +
                "</p><p>" +
                data.stuffingData[0].corporateAddress +
                "</p>";
              let dummyPOR = data.stuffingData[0].valPOR;
              dummyPOR = dummyPOR.replace(/,[^,]+$/, "");
              this.BLRaised.placeReceipt = dummyPOR.toUpperCase();

              let dummyLP = data.stuffingData[0].valLP;
              dummyLP = dummyLP.replace(/,[^,]+$/, "");
              this.BLRaised.portLoad = dummyLP.toUpperCase();

              let dummyPOD = data.stuffingData[0].valPodLocation;

              dummyPOD = dummyPOD.replace(/,[^,]+$/, "");
              this.BLRaised.portDischarge = dummyPOD.toUpperCase();
              let dummyfinal = data.stuffingData[0].valFinal;

              dummyfinal = dummyfinal.replace(/,[^,]+$/, "");

              this.BLRaised.placeDilievery = dummyfinal.toUpperCase();
              this.BLRaised.bookingNo = data.stuffingData[0].bookingNumber;
              this.BLRaised.typeMove = data.stuffingData[0].deliveryMode;
            } else {
              this.splitBlList = [];
              this.BLRaised.consignor =
                "<p>" +
                data.stuffingData[0].clientName +
                "</p><p>" +
                data.stuffingData[0].corporateAddress +
                "</p>";
              let dummyPOR = data.stuffingData[0].valPOR;
              dummyPOR = dummyPOR.replace(/,[^,]+$/, "");
              this.BLRaised.placeReceipt = dummyPOR.toUpperCase();

              let dummyLP = data.stuffingData[0].valLP;
              dummyLP = dummyLP.replace(/,[^,]+$/, "");
              this.BLRaised.portLoad = dummyLP.toUpperCase();

              let dummyPOD = data.stuffingData[0].valPodLocation;

              dummyPOD = dummyPOD.replace(/,[^,]+$/, "");
              this.BLRaised.portDischarge = dummyPOD.toUpperCase();
              let dummyfinal = data.stuffingData[0].valFinal;

              dummyfinal = dummyfinal.replace(/,[^,]+$/, "");

              this.BLRaised.placeDilievery = dummyfinal.toUpperCase();
              this.BLRaised.bookingNo = data.stuffingData[0].bookingNumber;
              this.BLRaised.typeMove = data.stuffingData[0].deliveryMode;
            }
            // console.log(data);
            if (data.BLNonData.length > 0) {
              if (data.BLNonData[0].loginTime) {
                this.BLRaised.blCreatedDate = data.BLNonData[0].loginTime.split(
                  " "
                )[0];
              }
            this.BLRaised.CreatedBY = data.BLNonData[0].CreatedBY;
            this.BLRaised.CreatedDate = data.BLNonData[0].CreatedDate;
            this.BLRaised.UpdatedBY = data.BLNonData[0].UpdatedBY;
            this.BLRaised.UpdatedDate = data.BLNonData[0].UpdatedDate;
              // this.BLRaised.createUpdate = data.BLNonData[0].UpdatedDate
              //   ? data.BLNonData[0].UpdatedDate
              //   : data.BLNonData[0].CreatedDate;
              // this.BLRaised.CreatedBY = data.BLNonData[0].UpdatedBY
              //   ? data.BLNonData[0].UpdatedBY
              //   : data.BLNonData[0].CreatedBY;
              this.BLDetailsList = data.BLNonData;
              if (
                this.sentAdditionalBL == 2 &&
                (this.$sessionsStorage.get("editfclBlId") == "" ||
                  this.$sessionsStorage.get("editfclBlId") == undefined ||
                  this.$sessionsStorage.get("editfclBlId") == null)
              ) {
                //  && this.$sessionsStorage.get("editfclBlId") ==undefined&&this.$sessionsStorage.get("editfclBlId")==null&&this.$sessionsStorage.get("editfclBlId")==""
                this.BLRaised.fclBlId = "";
                this.BLRaised.blStage = "";
                this.BLDetailsList[0].blStage = "";
              }
              if (
                this.BLDetailsList.length > 0 &&
                (this.BLDetailsList[0].blStage == "ORIGINAL" ||
                  this.BLDetailsList[0].blStage == "SEAWAY")
              ) {
                this.originalDone = true;
                this.BLRaised.blStage = "";
                if (this.BLDetailsList[0].mail_approved_status == "1") {
                  this.originalDone = false;
                }
              }

              if (this.BLDetailsList.length > 0) {
                this.prevBlStage = this.BLDetailsList[0].blStage;
              }
            }
            if (data.BLNonData.length > 0) {
              // this.blTableArray = data.BLNonData;
              data.BLNonData.forEach(element => {
                element["originalDone"] = false;
                if (
                  element.fclBlId != "" &&
                  element.fclBlId != undefined &&
                  (element.blStage == "ORIGINAL" || element.blStage == "SEAWAY")
                ) {
                  element["originalDone"] = true;
                  if (element.mail_approved_status == "1") {
                    element["originalDone"] = false;
                  }
                }
                this.blTableArray.push(element);
              });
            }
            if (data.BLNonDataPrev && data.BLNonDataPrev.descriptionGood && !this.$sessionsStorage.get("editfclBlId")) {
              this.BLRaised.descriptionGood =data.BLNonDataPrev.descriptionGood;
            }
            if (data.BLNonDataPrev && !this.$sessionsStorage.get("editfclBlId")){
              this.BLRaised.consignor =data.BLNonDataPrev.consignor;
              this.BLRaised.consignee =data.BLNonDataPrev.consignee;
              this.BLRaised.shippingReferenceNum =data.BLNonDataPrev.shippingReferenceNum;
              this.BLRaised.typeMove =data.BLNonDataPrev.typeMove;
              // this.BLRaised.notifyList =data.BLNonDataPrev.notifyList;
              this.BLRaised.preCarriage =data.BLNonDataPrev.preCarriage;
              this.BLRaised.vesselVoy =data.BLNonDataPrev.vesselVoy;
              this.BLRaised.agent_reference_id =data.BLNonDataPrev.agent_reference_id;
              this.BLRaised.portLoad =data.BLNonDataPrev.portLoad;
              this.BLRaised.portDischarge =data.BLNonDataPrev.portDischarge;
              this.BLRaised.placeDilievery =data.BLNonDataPrev.placeDilievery;
              this.BLRaised.desCharges =data.BLNonDataPrev.desCharges;
              this.BLRaised.prepaid =data.BLNonDataPrev.prepaid;
              this.BLRaised.collect =data.BLNonDataPrev.collect;
              this.BLRaised.placeBranch =data.BLNonDataPrev.placeBranch;
              this.BLRaised.delieveryAgent =data.BLNonDataPrev.delieveryAgent;
              this.BLRaised.agentAddress =data.BLNonDataPrev.agentAddress;
              this.BLRaised.forwarderName =data.BLNonDataPrev.forwarderName;
              this.BLRaised.forwarderContact =data.BLNonDataPrev.forwarderContact;
              this.BLRaised.forwarderEmail =data.BLNonDataPrev.forwarderEmail;
              this.BLRaised.forwarderAddress =data.BLNonDataPrev.forwarderAddress;
              this.BLRaised.agentName =data.BLNonDataPrev.agentName;
              this.BLRaised.agentContact =data.BLNonDataPrev.agentContact;
              this.BLRaised.agentEmail =data.BLNonDataPrev.agentEmail;
              this.BLRaised.total =data.BLNonDataPrev.total;
              this.BLRaised.portLocationType =data.BLNonDataPrev.portLocationType;
              this.BLRaised.bookingNo =data.BLNonDataPrev.bookingNo;
              this.BLRaised.placeReceipt =data.BLNonDataPrev.placeReceipt;
              this.BLRaised.pointofOrigin =data.BLNonDataPrev.pointofOrigin;
              this.BLRaised.consolidationNO =data.BLNonDataPrev.consolidationNO;
              this.BLRaised.exportReference =data.BLNonDataPrev.exportReference;
              this.BLRaised.SCAC =data.BLNonDataPrev.SCAC;
              this.BLRaised.loadingPreTerminal =data.BLNonDataPrev.loadingPreTerminal;
              this.BLRaised.reference =data.BLNonDataPrev.reference;
            }
            if (data.BLNonDataPrev && data.BLNonDataPrev.selected_container) {
              // alert(data.BLNonDataPrev.selected_container);
              this.autoSelectContainersFromData(data.BLNonDataPrev.selected_container);
            }
            this.getAgentColoaderList();
            this.getTrackingDetails();
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/freightForward/fclBLofLanding"
      // });
    },

    validateVGM() {
      let validate_new = true;

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    deleteData(id) {
      this.deleteItem = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// BLOtherUsNew.vue?0e4a5d98